import { IMetricData, IMetricOptions } from "@curefit/metrics-common"
import { IMetricServiceApis } from "./IMetricServiceApis"
import ApiUtils from "../ApiUtils"
import { IUserMetricSearchV2ReqParam, IUserMetricSearchV2Response } from "../../interfaces/api/metrics/IUserMetricSearchV2"
import { IAddMetric } from "../../interfaces/api/metric/IUserMetric"
import { IVitalUpsertRequest } from "../../interfaces/patient/IPatientVitals"

// const saveUserMetric: string = METRIC_SERVICE_API_PREFIX + "/user-metric";
// const saveUserMetricV2: string = METRIC_SERVICE_API_PREFIX + "/user-metric/searchV2";
// const saveUserMetricsUrl: string = METRIC_SERVICE_API_PREFIX + "/user-metric/values";
// const getGlucoseReadingsForUserUrl: string = METRIC_SERVICE_API_PREFIX + "/user-metric/search";
// const getCronicCareGlucoseUrl: string = METRIC_SERVICE_API_PREFIX + "/user-metric/value-with-range-label";
// const fetchMetricByIdUrl: string = METRIC_SERVICE_API_PREFIX + "/metrics/$metricId";
// const metricLabTestUrl = `/user-metric/diagnosti_profile`;
// const searchUserMetricUrl: string = METRIC_SERVICE_API_PREFIX + "/user-metric/searchV2";
// const upsertValuesUrl: string = METRIC_SERVICE_API_PREFIX + "/user-metric/upsert-values";

export const MetricServiceUrls = {
	saveUserMetricsUrl: "/user-metric/values",
	searchUserMetricUrl: (req: IUserMetricSearchV2ReqParam) => `/user-metric/searchV2?${ApiUtils.requestToQueryParams(req)}`,
	upsertMetrics: `/user-metric/upsert-values`,
}

export default class MetricServiceApis implements IMetricServiceApis {
	private getServiceUrl = (url: string) => `/metricService${url}`
	// saveUserMetric(req: IAddMetric): Promise<UserGoalView[]> {
	// 	return ApiUtils.apiPostRequest(saveUserMetric, JSON.stringify(req));
	// }
	//
	// fetchUserMetric(req: IMetricOptions): Promise<IMetricData[]> {
	// 	return ApiUtils.apiGetRequest(`${saveUserMetric}?${ApiUtils.requestToQueryParams(req)}`);
	// }
	fetchUserMetricV2(req: IMetricOptions): Promise<IMetricData[]> {
		const url = this.getServiceUrl(MetricServiceUrls.searchUserMetricUrl(req))
		return ApiUtils.get(url)
	}
	//
	// fetchStaticDiagnosticLabTests(input: string): Promise<IMetricData[]> {
	// 	return ApiUtils.apiGetRequest(AlbusUrlConfigs.createGetLabTestsUrl(input));
	// }
	//
	// savePatientDiagnosticLabTests(metric: ILabtestPrescription[]): Promise<any> {
	// 	return ApiUtils.apiPostRequest(saveUserMetricsUrl, JSON.stringify(metric));
	// }
	//
	// fetchGlucoseReadingsForPatient(params: IGlucoseReadingsForPatientParams): Promise<any> {
	// 	const urlParams = ApiUtils.requestToQueryParams({ ...params, source: "CMT" });
	// 	return ApiUtils.apiGetRequest(`${getGlucoseReadingsForUserUrl}?${urlParams}`);
	// }
	//
	// fetchChronicCareGlucose(params: ISugarJournalRequest): Promise<ISugarJournalResponse[]> {
	// 	const urlParams = ApiUtils.requestToQueryParams(params);
	// 	return ApiUtils.apiGetRequest(`${getCronicCareGlucoseUrl}?${urlParams}`);
	// }
	//
	// fetchMetricById(metricId: number) {
	// 	const url = fetchMetricByIdUrl.replace("$metricId", metricId.toString());
	// 	return ApiUtils.apiGetRequest(url);
	// }
	//
	searchUserMetricV2(req: IUserMetricSearchV2ReqParam): Promise<IUserMetricSearchV2Response> {
		const url = this.getServiceUrl(MetricServiceUrls.searchUserMetricUrl(req))
		return ApiUtils.get(url)
	}

	saveUserMetrics(metrics: IAddMetric[]): Promise<any> {
		const url = this.getServiceUrl(MetricServiceUrls.saveUserMetricsUrl)
		return ApiUtils.post(url, metrics)
	}
	//
	// fetchPatientLabTests(userId: number, patientId: number): Promise<any> {
	// 	const url = urlConfigHelper.getMetricServiceURL(`${metricLabTestUrl}?userId=${userId.toString()}&subUserId=${patientId}`);
	// 	return ApiUtils.apiGetRequest(url);
	// }
	//
	updateMetricValues(userMetrics: IVitalUpsertRequest[]): Promise<void> {
		return ApiUtils.post(this.getServiceUrl(MetricServiceUrls.upsertMetrics), userMetrics)
	}
}
